/* global slideUp, Cookies */
const notification = document.querySelector('.notification');

if (notification) {
  const closeNotification = notification.querySelector('.notification__close');

  closeNotification.addEventListener('click', () => {
    slideUp(notification, 500);
    Cookies.set('notification-view', 'true', { expires: 7 });
  });
}
